export const datepicker = {
  labels: {
    labelPrevDecade: 'Deceniul anterior',
    labelPrevYear: 'Anul anterior',
    labelPrevMonth: 'Luna anterioară',
    labelCurrentMonth: 'Luna curentă',
    labelNextMonth: 'Luna următoare',
    labelNextYear: 'Anul următor',
    labelNextDecade: 'Următorul deceniu',
    labelToday: 'Azi',
    labelSelected: 'Data selectată',
    labelNoDateSelected: 'Nicio dată selectată',
    labelCalendar: 'Calendar',
    labelNav: 'Navigare',
    labelHelp: 'Ajutor'
  },
  startWeekday: 1
}
